import { render, staticRenderFns } from "./CapitalApplicationAuditHistory.vue?vue&type=template&id=bff6b8c4&scoped=true&"
import script from "./CapitalApplicationAuditHistory.vue?vue&type=script&lang=ts&"
export * from "./CapitalApplicationAuditHistory.vue?vue&type=script&lang=ts&"
import style0 from "./CapitalApplicationAuditHistory.vue?vue&type=style&index=0&id=bff6b8c4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bff6b8c4",
  null
  
)

export default component.exports